/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { EmployeeHubListVO } from '@well/delivery-libs/employee/domain';

@Injectable({ providedIn: 'root' })
export class EmployeeHubListVoResourceService extends AbstractResourceService<
    EmployeeHubListVO,
    EmployeeHubListVO,
    null,
    null
  > {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('employeeHubListUrl'),
      EmployeeHubListVO,
      EmployeeHubListVO,
      undefined
    );
  }
}
